/**
 * Header Navigation Data
 */

import { PATHS } from '@/routes/paths';

export interface MenuItem {
    label: string;
    path: string;
}

export const menuItems: MenuItem[] = [
    { label: 'Home', path: PATHS.HOME },
    { label: 'Real Estate', path: PATHS.REALESTATE },
    { label: 'Open Houses', path: PATHS.OPEN_HOUSE },
    { label: 'Articles', path: PATHS.POSTS },
    { label: 'Affordability Calculator', path: PATHS.MORTGAGE_CALCULATOR },
    { label: "What's My Home Worth?", path: PATHS.HOME_VALUE },
    { label: 'Agreements', path: PATHS.OUR_AGREEMENTS },
    { label: 'Services', path: PATHS.SERVICES },
    { label: 'About', path: PATHS.ABOUT },
    { label: 'Contact', path: PATHS.CONTACT },
    { label: 'Book Appointment', path: PATHS.BOOK_APPOINTMENT },
];

/** The phone menu shows the same items; kept as its own export for the Header. */
export const mobileMenuItems: MenuItem[] = menuItems;
